/* src/components/DashbaordLayout.js */
import { RouterView, RouterLink, useRoute } from 'vue-router'
import { computed, ref, watch } from 'vue'
import { 
  Package, 
  CalendarClock, 
  Box, 
  GraduationCap, 
  Users, 
  UserCircle, 
  CalendarDays, 
  CreditCard,
  LogOut,
  Menu,
  Ticket,
  X 
} from 'lucide-vue-next'

export default {
  name: 'DashboardLayout',
  components: {
    RouterView,
    RouterLink,
    Package,
    CalendarClock,
    Box,
    GraduationCap,
    Users,
    UserCircle,
    CalendarDays,
    CreditCard,
    LogOut,
    Menu,
    X
  },
  setup() {
    const route = useRoute()
    const isMobileMenuOpen = ref(false)

    const menuItems = [
      { name: 'Gestione servizi', path: '/services', icon: Package },
      { name: 'Gestione giorni/orari', path: '/opening-hours', icon: CalendarClock },
      { name: 'Gestione risorse', path: '/resources', icon: Box },
      { name: 'Gestione competenze', path: '/skills', icon: GraduationCap },
      { name: 'Gestione operatori', path: '/operators', icon: Users },
      { name: 'Gestione clienti', path: '/customers', icon: UserCircle },
      { name: 'Gestione appuntamenti', path: '/appointments', icon: CalendarDays },
      { name: 'Gestione rimborsi', path: '/voucher', icon:  Ticket},
      { name: 'Gestione settaggi', path: '/settings', icon: CreditCard },
    ]

    const isActive = (path) => route.path.startsWith(path)

    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value
    }

    const closeMobileMenu = () => {
      isMobileMenuOpen.value = false
    }

    // Chiude il menu automaticamente quando si cambia pagina
    watch(() => route.path, () => {
      closeMobileMenu()
    })

    return {
      menuItems,
      isActive,
      isMobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu
    }
  }
}